import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/test/table2';
import Container from '../../containers/dashboard';
import Root from '../../components/root';

export default function Test2() {
  return (
    <Root title={PAGE_TITLE.TEST2}>
      <Container>
        <Component/>
      </Container>
    </Root>
  );
};
